import { MuiColorInput, type MuiColorInputProps } from 'mui-color-input';
import { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingIds } from '~/components/settings';

/** A colour field inside a settings row, named by the row's `SettingName`. */
export const DetailColorInput = (props: MuiColorInputProps) => {
  const { t } = useTranslation();
  const ids = useSettingIds();
  const ref = useRef<HTMLDivElement>(null);

  // The library renders its swatch button with no accessible name and offers no prop for one.
  useLayoutEffect(() => {
    ref.current
      ?.querySelector('button')
      ?.setAttribute('aria-label', t('common.actions.open_color_picker'));
  });

  return <MuiColorInput id={ids?.inputId} ref={ref} {...props} />;
};
